import "./History.scss";
import { PlainTable } from "../../../../../../../components/ui/PlainTable/PlainTable";
import { IconSvg } from "../../../../../../../utils/constants/icons/iconSvg.constant";
import { useTranslation } from "../../../../../../../hooks";

const data = [
  {
    ip: "148.22.225.64",
    listName: "",
    selected: false,
    action: null
  },
  {
    ip: "148.22.225.64",
    listName: "Mix Europe",
    selected: true,
    action: null
  }
];

export const History = () => {
  const { cabinet: { orders: { residential: {
    historyTableTitle, noDataHistoryTable
  } } } } = useTranslation();
  return (
    <div className="residential-history-wrapper">
      <div className="residential-history">
        <div className="residential-history__head">
          <div className="residential-history__title">{historyTableTitle}</div>
        </div>
        {data.length ? (
          <PlainTable data={data}/>
        ) : (
          <div className="residential-history__no-data">
            <IconSvg tag="proxyListEmpty"/>
            <div className="residential-history__no-data-text">{noDataHistoryTable}</div>
          </div>
        )}
      </div>
    </div>
  );
};
